import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Breadcrums from "../common/breadcrumbs";
import { useFormik } from "formik";
import Swal from "sweetalert2";

import { AddPermissions, detailsPermissions } from "../services/staff.services";
import { globalLoader, handleServerValidations } from "../../../utils/commonfunction";
import { SWAL_SETTINGS } from "../../../utils/Constants";

const PermissionsTable = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const params = useParams();

    const breadcrumbs = [
        { title: t("admin.inquiry.link_dashboard"), url: "/admin/dashboard/1" },
        { title: t("Staff"), url: "/admin/staff/list/1" },
        { title: t("Staff Permissions"), url: "" },
    ];

    const permissionsList = [
        // { moduleName: "Center Management", moduleSlug: "center_management" },
        // { moduleName: "Doctor Management", moduleSlug: "doctor_management" },
        { moduleName: "Patient Management", moduleSlug: "patient_management" },
        // { moduleName: "Medicine Management", moduleSlug: "medicine_management" },
        { moduleName: "Appointment Management", moduleSlug: "appointment_management" },
        { moduleName: "Appointment Management(Staff)", moduleSlug: "management-section" },
        // { moduleName: "CMS Page", moduleSlug: "cms_page" },
        // { moduleName: "FAQ", moduleSlug: "faq" },
        // { moduleName: "Video", moduleSlug: "video" },
        // { moduleName: "Email Template", moduleSlug: "email_template" },
        // { moduleName: "General Setting", moduleSlug: "general_settings" },
        // { moduleName: "Inquires", moduleSlug: "inquires" },
    ];

    const addForm = useFormik({
        enableReinitialize: true,
        initialValues: {
            permissions: [],
        },
        validateOnBlur: false,
        onSubmit: (values, { resetForm }) => {
            globalLoader(true);
            let formData = new FormData();
            formData.append("staff_id", params?.id);
            formData.append("staff_permissions", JSON.stringify(values.permissions));

            AddPermissions(formData)
                .then((response) => {
                    if (response.success) {
                        Swal.fire({
                            icon: "success",
                            text: response.message,
                            ...SWAL_SETTINGS,
                        });
                        globalLoader(false);
                        resetForm({ values: { permissions: [] } });
                        navigate(`/admin/staff/list/1`);
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: handleServerValidations(response),
                            ...SWAL_SETTINGS,
                        });
                        globalLoader(false);
                    }
                })
                .catch((error) => {
                    console.log("error ====> ", error);
                    globalLoader(false);
                });
        },
    });

    useEffect(() => {
        let formData = new FormData();
        formData.append("staff_id", params?.id);
        detailsPermissions(formData)
            .then((response) => {
                const permissions = response?.data || [];
                addForm.setFieldValue("permissions", permissions);
            })
            .catch((error) => {
                console.log("error=====>", error);
            });
    }, [params.id]);

    const handlePermissionToggle = (module) => {
        const currentPermissions = addForm.values.permissions;
        const exists = currentPermissions.some(
            (p) => p.module_slug === module.moduleSlug
        );

        const updatedPermissions = exists
            ? currentPermissions.filter((p) => p.module_slug !== module.moduleSlug)
            : [
                  ...currentPermissions,
                  {
                      module_name: module.moduleName,
                      module_slug: module.moduleSlug,
                  },
              ];

        addForm.setFieldValue("permissions", updatedPermissions);
    };

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <form onSubmit={addForm.handleSubmit}>
                <div className="animation_fade">
                    <div className="card custom-card">
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center mb-4">
                                <h6 className="main-content-label">{t("Staff Permissions")}</h6>
                            </div>
                            <div className="permissions-wrapper">
                                {permissionsList.length ? (
                                    permissionsList.map((module, index) => {
                                        const isChecked = addForm.values.permissions.some(
                                            (p) => p.module_slug === module.moduleSlug
                                        );
                                        return (
                                            <div className="permission-module mb-3" key={index}>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input cp"
                                                        type="checkbox"
                                                        id={`module_${module.moduleSlug}`}
                                                        checked={isChecked}
                                                        onChange={() => handlePermissionToggle(module)}
                                                    />
                                                    <label
                                                        className="form-check-label cp"
                                                        htmlFor={`module_${module.moduleSlug}`}
                                                    >
                                                        {t(module.moduleName)}
                                                    </label>
                                                </div>
                                            </div>
                                        );
                                    })
                                ) : (
                                    <div className="text-center">
                                        {t("admin.message.msg_no_records")}
                                    </div>
                                )}
                            </div>
                            <div className="mt-5">
                                <button
                                    className="btn btn-info"
                                    type="submit"
                                    disabled={addForm.values.permissions.length === 0}
                                >
                                    <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                                    {t("admin.button.btn_submit")}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </>
    );
};

export default PermissionsTable;
